import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { ShipmentManifest } from '../model/ShipmentManifest';

@Injectable()
export class ShipmentManifestFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetAllByDeliveryCode(deliveryCode, language: number, organizationId = null): Observable<RequestResponse<[ShipmentManifest]>> {
        if (organizationId != null ) {
            return this._httpClient.get<RequestResponse<[ShipmentManifest]>>(this._urlBase
                + 'api/ShipmentManifest/Web?deliveryCode=' + deliveryCode + '&language=' + language + '&organizationId=' + organizationId);
        } else {
            return this._httpClient.get<RequestResponse<[ShipmentManifest]>>(this._urlBase
                 + 'api/ShipmentManifest/Web?deliveryCode=' + deliveryCode + '&language=' + language);
        }
    }

    Cancel(manifestNumber): Observable<RequestResponse<number>> {
        return this._httpClient.get<RequestResponse<number>>(this._urlBase + '/api/ShipmentManifest/Cancel?Code=' + manifestNumber);
    }
}
